import React from 'react';
import {IconCheck,IconArrowRight} from './Icons';
import {BOOK_URL,PACKAGES,STARTING_PRICE,SETUP_OFFER,FAIR_USE} from '../siteConfig';

function PricingCard() {
  return (
    <>
      <div className="plan-grid">
        {PACKAGES.map((p)=> (
          <article className={p.popular ? 'plan-card wl' : 'plan-card'} key={p.id}>
            <h3 className="plan-name">
              {p.name}
              {p.popular && <em className="plan-soon">Most popular</em>}
            </h3>
            <p className="plan-for">{p.for}</p>
            <p className="plan-price">${p.price}<small>/month</small></p>
            <p className="plan-extra">+ ${p.setup} one-time setup</p>
            <ul className="plan-list">
              {p.features.map((text)=> (
                <li key={text}><IconCheck /><span>{text}</span></li>
              ))}
            </ul>
            <a className="primary-button" href={BOOK_URL}>Book a free call <IconArrowRight /></a>
          </article>
        ))}
      </div>
      <p className="setup-note">
        {SETUP_OFFER && <><b>{SETUP_OFFER}</b><br /></>}
        Need just one thing? Individual services start at ${STARTING_PRICE}/month. No long-term contracts. Cancel anytime.
        <br /><small>{FAIR_USE}</small>
      </p>
    </>
  );
}

export default PricingCard;
